// This takes in users in a dictionary of users {firstName-lastName-userId-orderTime}
// and then calculates the order totals and creates a payment entry for the user.
// It loads the PaymentHisory and add the new entries to it.  It needs to receive
// the communityOrders to know the user's orders.
import CreatePaymentData from "./../CreatePaymentData.js";
import CalculateOrderTotals from "./CalculateOrderTotals.js";

export default function AddPaymentEntries(
  communityOrdersPaymentHistory,
  newOrders,
  distributionLocation,
  communityOrders,
) {
  // Loads the existing payment data.
  const communityOrdersPaymentHistoryTemp =
    { ...communityOrdersPaymentHistory } || {};
  // Since we want to order the user's order history from oldest to newest we have to
  // sort the order.
  const userOrders = Object.keys(newOrders).slice();
  userOrders.sort();
  // Cycle through all the communityOrders
  userOrders.forEach((userOrder) => {
    // Calculate the user totals.  The boolean tells CalculateOrderTotals to includeVolunteerFees
    // returns a dictionary {firstName-lastName-userId : orderTotal}
    const usersToAddTotals = CalculateOrderTotals(
      [userOrder],
      communityOrders,
      true,
    );

    // Split the user's name up to remove the date of the order as that is stored in
    // the orderHistory key.
    const user = [
      userOrder.split("-")[0],
      userOrder.split("-")[1],
      userOrder.split("-")[2],
    ].join("-");
    // Store the date of the user's order separately to be used later.
    const userOrderTime = userOrder.split("-")[3];

    // Add them entry to the paymentHistory.
    communityOrdersPaymentHistoryTemp[user] = CreatePaymentData(
      communityOrdersPaymentHistoryTemp[user],
      usersToAddTotals[user], // orderCost,
      userOrderTime,
      distributionLocation,
      communityOrders[userOrder].paymentMethod,
    );
  });

  return communityOrdersPaymentHistoryTemp;
}
